var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dorm_right1"}},[_c('div',{staticClass:"main-value noback_list"},[_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"100%"},attrs:{"config":_vm.config}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }